class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      const input = event.target.closest('input[data-as-spec-group]');
      if (!input || !input.checked) return;
      facetForm.querySelectorAll('input[data-as-spec-group]').forEach((other) => {
        if (other !== input && other.dataset.asSpecGroup === input.dataset.asSpecGroup) other.checked = false;
        if (input.dataset.asSpecGroup === 'Application' &&
            ['Tip series', 'Tip size', 'Cutting thickness', 'Welding thickness', 'Brazing thickness', 'Barrel length'].includes(other.dataset.asSpecGroup)) other.checked = false;
      });
    }, true);
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        const sliderControl = event.target.dataset.asFocusControl;
        if (sliderControl) {
          queueMicrotask(() => document.getElementById(sliderControl)?.focus({ preventScroll: true }));
        } else if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    queueMicrotask(() => document.querySelectorAll('as-gas-spec-group').forEach(group => group.sortValues?.()));
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.querySelectorAll('.js-filter > summary').forEach((summary) => {
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', String(summary.parentElement.open));
    });
    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.fields = [...this.querySelectorAll('input[data-price-field]')];
    [this.minField, this.maxField] = this.fields;
    this.sliders = [...this.querySelectorAll('.as-price-slider')];
    this.limit = this.number(this.maxField.dataset.max);
    this.minSubmit = this.querySelector('[data-price-submit="min"]');
    this.maxSubmit = this.querySelector('[data-price-submit="max"]');
    this.fields.forEach((field) => {
      field.addEventListener('input', (event) => this.onTextInput(event));
      field.addEventListener('change', () => this.commitText());
      field.addEventListener('keydown', (event) => {
        if (event.ctrlKey || event.metaKey) return;
        if (!/^[0-9.,' ]$|^(Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape|Home|End)$/.test(event.key)) event.preventDefault();
        if (event.key === 'Enter') {
          event.preventDefault();
          this.commitText();
        }
      });
    });
    this.sliders.forEach((slider) => {
      slider.addEventListener('input', (event) => {
        event.stopPropagation();
        clearTimeout(this.textTimer);
        this.moveSlider(slider);
      });
      slider.addEventListener('change', () => this.emitInput(slider.dataset.bound === 'min' ? this.minField : this.maxField));
    });
    this.sync();
    if (this.sliders.length === 2 && this.limit > 0) {
      this.querySelector('.as-price-sliders').hidden = false;
      this.querySelector('.as-price-limits').hidden = false;
    }
  }

  disconnectedCallback() {
    clearTimeout(this.textTimer);
  }

  number(value) {
    const parsed = Number(String(value).replace(/[,'\s]/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  clamp(value, minimum, maximum) {
    return Math.round(Math.max(minimum, Math.min(maximum, value)) * 100) / 100;
  }

  onTextInput(event) {
    if (this.emitting) return;
    event.stopPropagation();
    clearTimeout(this.textTimer);
    this.textTimer = setTimeout(() => this.commitText(), 800);
  }

  commitText() {
    clearTimeout(this.textTimer);
    const minimum = this.clamp(this.number(this.minField.value), 0, this.limit);
    const maximum = this.maxField.value.trim() ? this.clamp(this.number(this.maxField.value), minimum, this.limit) : this.limit;
    if (this.minField.value.trim()) this.minField.value = minimum;
    if (this.maxField.value.trim()) this.maxField.value = maximum;
    this.sync();
    this.emitInput(this.minField);
  }

  moveSlider(slider) {
    const minimum = this.minField.value.trim() ? this.number(this.minField.value) : 0;
    const maximum = this.maxField.value.trim() ? this.number(this.maxField.value) : this.limit;
    const value = slider.dataset.bound === 'min'
      ? this.clamp(Number(slider.value), 0, maximum)
      : this.clamp(Number(slider.value), minimum, this.limit);
    const field = slider.dataset.bound === 'min' ? this.minField : this.maxField;
    field.value = (slider.dataset.bound === 'min' && value === 0) || (slider.dataset.bound === 'max' && value === this.limit) ? '' : value;
    this.sync();
  }

  sync() {
    const minimum = this.clamp(this.number(this.minField.value), 0, this.limit);
    const maximum = this.maxField.value.trim() ? this.clamp(this.number(this.maxField.value), minimum, this.limit) : this.limit;
    this.minSubmit.value = this.minField.value.trim() && minimum > 0
      ? (Math.ceil(Math.round(minimum * 100) * 10 / 11) / 100).toFixed(2) : '';
    this.maxSubmit.value = this.maxField.value.trim() && maximum < this.limit
      ? ((Math.ceil((Math.round(maximum * 100) + 1) * 10 / 11) - 1) / 100).toFixed(2) : '';
    this.minField.dataset.max = maximum;
    this.maxField.dataset.min = minimum;
    this.sliders.forEach((slider) => {
      slider.value = slider.dataset.bound === 'min' ? minimum : maximum;
      slider.setAttribute('aria-valuetext', String(slider.value));
      slider.setAttribute(slider.dataset.bound === 'min' ? 'aria-valuemax' : 'aria-valuemin', slider.dataset.bound === 'min' ? maximum : minimum);
      slider.style.zIndex = slider.dataset.bound === 'min' && minimum === this.limit ? '3' : '2';
    });
    const rail = this.querySelector('.as-price-sliders');
    if (rail && this.limit) {
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.querySelector('[data-price-label="min"]').textContent = rail.dataset.symbol + formatter.format(minimum);
      this.querySelector('[data-price-label="max"]').textContent = rail.dataset.symbol + formatter.format(maximum);
      rail.style.setProperty('--as-range-start', minimum / this.limit * 100 + '%');
      rail.style.setProperty('--as-range-end', maximum / this.limit * 100 + '%');
    }
  }

  emitInput(field) {
    if (!this.isConnected) return;
    this.emitting = true;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    this.emitting = false;
  }
}

customElements.define('price-range', PriceRange);

class ASMeasurementFacet extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    queueMicrotask(() => this.initialize());
  }

  initialize() {
    if (!this.isConnected || this.initialized) return;
    this.inputs = [...this.querySelectorAll('.as-measurement-fallback input')];
    const parsed = this.inputs.map((input) => {
      const match = input.dataset.label.match(/^(?:Up to\s+)?(\d+(?:[.,]\d+)?)\s*mm$/i);
      return { input, number: match ? Number(match[1].replace(',', '.')) : NaN };
    });
    if (!parsed.length || parsed.some((point) => !Number.isFinite(point.number))) return;
    this.points = parsed.filter((point) => !point.input.disabled || point.input.checked).sort((a, b) => a.number - b.number);
    if (!this.points.length || new Set(this.points.map((point) => point.number)).size !== this.points.length) return;
    this.capacity = this.dataset.mode === 'capacity';
    if (this.capacity && this.dataset.operator === 'AND') return;
    const selected = this.points.filter((point) => point.input.checked);
    if (!this.capacity && selected.length > 1) return;
    if (this.capacity && selected.length) {
      const minimum = Math.min(...selected.map((point) => point.number));
      if (this.points.some((point) => point.input.checked !== (point.number >= minimum))) return;
    }
    this.slider = this.querySelector('.as-measurement-slider');
    this.output = this.querySelector('output');
    this.slider.max = this.points.length;
    this.slider.value = selected.length ? this.points.findIndex((point) => point.input.checked) + 1 : 0;
    if (this.capacity) this.querySelector('label').textContent = this.dataset.minimum;
    this.querySelector('.as-range-upper-limit').textContent = this.points.at(-1).number + this.dataset.unit;
    this.slider.addEventListener('input', (event) => {
      event.stopPropagation();
      this.update();
    });
    this.slider.addEventListener('change', () => this.apply());
    this.querySelector('.as-range-reset').addEventListener('click', (event) => {
      event.stopImmediatePropagation();
      this.slider.value = 0;
      this.apply();
    }, true);
    this.querySelector('.as-measurement-fallback').hidden = true;
    this.querySelector('.as-measurement-controls').hidden = false;
    this.initialized = true;
    this.update();
  }

  update() {
    const point = this.points[Number(this.slider.value) - 1];
    const label = point ? (this.capacity ? this.dataset.minimum + ' ' : '') + point.number + this.dataset.unit : this.dataset.any;
    this.output.textContent = label;
    this.slider.setAttribute('aria-valuetext', label);
    this.slider.style.setProperty('--as-range-position', Number(this.slider.value) / this.points.length * 100 + '%');
    this.querySelector('.as-range-reset').disabled = !point;
  }

  apply() {
    const point = this.points[Number(this.slider.value) - 1];
    this.inputs.forEach((input) => input.checked = false);
    if (point) this.points.forEach((candidate) => candidate.input.checked = this.capacity ? candidate.number >= point.number : candidate === point);
    this.update();
    this.dataset.asFocusControl = this.slider.id;
    this.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('as-measurement-facet', ASMeasurementFacet);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);



// Sort normalized sizes and capacities numerically after each section refresh.
if (!customElements.get('as-gas-spec-group')) {
  customElements.define('as-gas-spec-group', class extends HTMLElement {
    connectedCallback() {
      this.sortValues();
    }
    sortValues() {
      const list = this.querySelector('ul');
      if (!list) return;
      Array.from(list.children)
        .sort((a, b) => a.dataset.asSpecLabel.localeCompare(b.dataset.asSpecLabel, undefined, { numeric: true }))
        .forEach((item) => list.appendChild(item));
    }
  });
}
